import darkDefault from './default';
import darkCompact from './compact';
import darkNative from './native';

export default {
    default: darkDefault,
    compact: darkCompact,
    native: darkNative
};
